import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Social } from 'functions/src/types/Social';
import { AvatarNext } from '../AvatarNext';
import { SocialIcons } from '../socials/SocialIcons';

export type TeamMemberCardProps = {
  photo: string;
  name: string;
  role: string;
  socialLinks?: Social[];
  description?: string;
  eagerLoad?: boolean;
};

export function TeamMemberCard(props: TeamMemberCardProps) {
  const theme = useTheme();
  const {
    photo,
    name,
    role,
    socialLinks,
    description,
    eagerLoad = false,
  } = props;
  return (
    <Stack
      alignItems="center"
      sx={{
        width: '360px',
        height: '616px',
        ...theme.panels[4],
        ...theme.glow.panel,
      }}
    >
      <Box
        sx={{
          borderRadius: '100%',
          mb: '3.5px',
          border: 'solid 3px transparent',
          backgroundImage:
            'linear-gradient(rgba(13,31,50,1), rgba(13,31,50,1)), linear-gradient(90deg, #4DC8FF -25%, #0064E9 200%)',
          backgroundOrigin: 'border-box',
          backgroundClip: 'content-box, border-box',
        }}
      >
        <AvatarNext
          src={photo}
          alt={name}
          eagerLoad={eagerLoad}
          sx={{
            width: '209px',
            height: '209px',
          }}
        />
      </Box>
      <Typography variant="h5" sx={{ textTransform: 'capitalize' }}>
        {name}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ textTransform: 'capitalize' }}
      >
        {role}
      </Typography>
      {socialLinks && (
        <List
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexFlow: 'row wrap',
            mx: 8,
          }}
        >
          <SocialIcons
            wrapperSX={{ '& svg': { maxWidth: '32px' } }}
            linkedSocials={socialLinks}
            gradient
          />
        </List>
      )}
      <Typography
        variant="subtitle2"
        color="text.secondary"
        sx={{ textAlign: 'center' }}
      >
        {description}
      </Typography>
    </Stack>
  );
}
